import type { ChatMessage } from '@/types/chat';

/** The assistant message a running response belongs to — the last one in the thread. */
export const getLatestAssistantMessage = (messages: ChatMessage[]): ChatMessage | undefined => {
  for (let i = messages.length - 1; i >= 0; i -= 1) {
    if (messages[i]?.role === 'assistant') return messages[i];
  }
  return undefined;
};
